<script lang="ts" setup>
  import { BaseButton, Menu, Flag } from '@bt/design-system'
  import { availableLocales, setPathByLocale, selectedLocale } from '@/composables/languageSwitcher'

  defineProps<{
    items: any
  }>()
  const { locale } = useI18n()
  const isLanguageSwitcherVisible = ref(false)
  const isSidebarMenuVisible = ref(false)

  const avLocales = computed(() => availableLocales())
  const selectedLoc = computed(() => selectedLocale())

  const onMenuClick = (item: any) => {
    isSidebarMenuVisible.value = false
    emit('change', item.currentItem)
  }

  const emit = defineEmits(['change', 'refreshAllData'])

  const toggleSidebarMenu = () => {
    isSidebarMenuVisible.value = !isSidebarMenuVisible.value
    isLanguageSwitcherVisible.value = false
  }

  const onLangChange = (value: string) => {
    toggleSidebarMenu()
    setPathByLocale(value)
    emit('refreshAllData', value)
  }
</script>

<template>
  <div class="mobile-main-nav">
    <NuxtLink :to="`/${locale}/`">
      <img
        class="bt-logo"
        height="19"
        src="/bt-logo.svg"
        width="81"
        alt="airBaltic logo"
        title="airBaltic logo"
      />
    </NuxtLink>
    <MobileSidebar
      v-model="isSidebarMenuVisible"
      :is-sub-view-active="isLanguageSwitcherVisible"
      @close-sub-view="() => (isLanguageSwitcherVisible = false)"
    >
      <template #logo>
        <NuxtLink :to="`/${locale}/`">
          <img
            class="bt-logo"
            height="27"
            src="/bt-logo.svg"
            width="120"
            alt="airBaltic logo"
            title="airBaltic logo"
          />
        </NuxtLink>
      </template>
      <template #menu>
        <Menu
          :items="items"
          dividers
          width="full"
          @change="onMenuClick"
        />
      </template>
      <template #sub-view-content>
        <Menu
          width="full"
          dividers
          has-end-divider
          :items="avLocales"
        >
          <template #custom-menu-item="{ item, className }">
            <div
              class="lang-item"
              :class="className"
              @click="onLangChange(item.code)"
            >
              <Flag :code="item.key" />
              {{ item.title }}
            </div>
          </template>
        </Menu>
      </template>
      <template #extra-content>
        <div class="mobile-lang-switch pl-4 gap-3">
          <i class="md-icon md-24 text-bt-brand-dark-blue"> language </i>
          <div @click="() => (isLanguageSwitcherVisible = true)">{{ selectedLoc.label }}</div>
        </div>
      </template>
    </MobileSidebar>

    <BaseButton
      icon="menu"
      type="text"
      @click="toggleSidebarMenu"
    />
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/styles/common.scss';

  .mobile-main-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: rem(8);
  }

  .mobile-lang-switch {
    display: flex;
    align-items: center;
  }

  .logo-link {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .lang-item {
    display: flex;
    gap: rem(16);
    align-items: center;
  }
</style>
